import { defineMessages } from 'react-intl';

export const messages: {
	buttonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	inspirationText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	placeholderText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	buttonText: {
		id: 'company-hub.common.media-components.unsplash.unsplash-browser.button.text',
		defaultMessage: 'Browse unsplash',
		description: 'Text of button to browse background choices from Unsplash',
	},
	errorText: {
		id: 'company-hub.common.media-components.unsplash.unsplash-browser.error.text',
		defaultMessage: 'We had trouble accessing this link. Try again.',
		description: 'Error text to inform that the link is invalid',
	},
	inspirationText: {
		id: 'company-hub.common.media-components.media-picker.ui.content.inspiration.text',
		defaultMessage: 'Need inspiration?',
		description:
			'Text for button to seek inspiration from third party platform to eventually paste background url of choice',
	},
	placeholderText: {
		id: 'company-hub.common.media-components.media-picker.ui.content.placeholder.text',
		defaultMessage: 'Add link from URL',
		description: 'Textfield placeholder to paste unsplash url of choice',
	},
});
